import { Signal } from '@angular/core';
import { DialogSize } from '@wcg/frontend-framework';
import { REPLACE_DOCUMENT_DIALOG_TITLE } from '../contants';
import {
  ReplaceDocumentDialog,
  ReplaceDocumentPayload,
  SubmittedDocument,
} from '../types';

/**
 * ERM-12396/12397 Replace Document dialog payload: the dialog stays presentational,
 * the store owns the call and flips `$canCloseDialog` when it lands.
 * @param params The row's document, the store's dialog signals, the replace
 * callback, and optional title/size overrides.
 * @returns The MAT_DIALOG_DATA payload for {@link ReplaceDocumentDialog}.
 */
export function createReplaceDocumentDialogPayload(params: {
  document: SubmittedDocument;
  $canCloseDialog: Signal<boolean>;
  $isLoading: Signal<boolean>;
  $acceptAttribute: Signal<string>;
  replaceDocument: (payload: ReplaceDocumentPayload) => void;
  dialogTitle?: string;
  dialogSize?: DialogSize;
}): ReplaceDocumentDialog {
  return {
    $acceptAttribute: params.$acceptAttribute,
    $canCloseDialog: params.$canCloseDialog,
    $isLoading: params.$isLoading,
    callBacks: {
      replaceDocument: params.replaceDocument,
    },
    dialogSize: params.dialogSize ?? DialogSize.MEDIUM,
    dialogTitle: params.dialogTitle ?? REPLACE_DOCUMENT_DIALOG_TITLE,
    document: params.document,
  };
}
